import {Message} from "element-ui";
import AxiosInstance from "@/http/baseAxios";

const axiosInstance = new AxiosInstance(
	(config) => {
		return config;
	},
	(error) => error,
	(response) => {
		if (response.data.code !== "0" && response.data.msg) {
			Message({
				message: response.data.msg,
				showClose: true,
				type: "error",
			});
		}
		return response.data;
	},
	(error) => {
		if (error.response && error.response.status === 500) {
			Message({
				message: "服务器内部错误，请联系相关人员反馈问题！",
				showClose: true,
				type: "error",
			});
		}
		return error;
	},
	{
		// baseURL: process.env.NODE_ENV === "development" ? "http://10.10.30.7:8080" : "http://39.98.193.239:9999",
		baseURL: "http://39.98.193.239:9999",
	},
);

export {axiosInstance};
